import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { newI18n } from '../core/Const';
export interface TopHeaderProps extends BaseComponentProps {
    lang: string;
}
export interface TopHeaderState extends BaseComponentState { }
export class TopHeader extends BaseComponent<TopHeaderProps, TopHeaderState> {
    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        return (
            <div id="topbar" className="clearfix ">
                <div className="container">
                    <div className="col-sm-8 col-xs-12">
                        <div className="callus desktop-only">
                            {newI18n("TOPHEADER.EmailUs", "Email Us")} -  <a href="mailto:info@balihotelsandmore.com">info@balihotelsandmore.com</a>, 
                             IND <a href="https://wa.me/+6287860006919" target="_blank"> +62 878 6000 6919 </a>  {newI18n("GENERAL.or", "or")}  AUS <a href="cal:1300 582 556" target="_blank">1300 582 556</a>  {newI18n("GENERAL.or", "or")}  UK <a href="cal:+442081335522" target="_blank">+442081335522</a>
                        </div>
                        <div className="callus mobile-only" style={{ textAlign: 'center' }}>
                            <a href="mailto:info@balihotelsandmore.com"> <i className="ti-email" />  {newI18n("TOPHEADER.EmailUs", "Email Us")}  </a> - <a href="https://wa.me/+6287860006919"> WhatsApp <i className="fa fa-whatsapp" /> </a>   {newI18n("GENERAL.or", "or")} <a href="cal:1300 582 556"> <i className="fa fa-phone"/> AUS  </a> {newI18n("GENERAL.or", "or")} <a href="cal:+442081335522"> <i className="fa fa-phone"/> UK  </a>
                             
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="social-icons hidden-xs" >
                            <ul>
                                <li data-placement="bottom" data-original-title="Instagram" className="social-instagram tooltips">
                                    <a href="https://www.instagram.com/balihotelsandmore/" target="_blank"> Instagram </a>
                                </li>
                                <li data-placement="bottom" data-original-title="Facebook" className="social-facebook tooltips">
                                    <a href="https://www.facebook.com/balihotelsandmore/" target="_blank"> Facebook </a>
                                </li>
                                <li data-placement="bottom" data-original-title="Google" className="social-google tooltips">
                                    <a href="https://plus.google.com/u/0/118003393109007884268" target="_blank"> Google+ </a>
                                </li>
                                <li data-placement="bottom" data-original-title="YouTube" className="social-youtube tooltips">
                                    <a href="https://www.youtube.com/channel/UCvgh4XxtRm3yf7K3jGe_OwA?view_as=subscriber" target="_blank"> YouTube </a>
                                </li>
                                <li data-placement="bottom" data-original-title="TripAdvisor" className="social-tripadvisor tooltips">
                                    <a href="https://www.tripadvisor.com/Attraction_Review-g303952-d13993230-Reviews-Bali_Tours_And_More-Kintamani_Bangli_Bali.html" target="_blank"> TripAdvisor </a>
                                </li> 
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/header/TopHeader.tsx